export default {
  name: 'validate-alert',
  mixins: [],
  extends: {},
  components: {},
  props: ['msg'],
  data() { return {}; },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    close() {
      this.$emit('close');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/service/alert/validate-alert.js